import React from "react";
import classNames from "classnames";
import styles from "./Layout.module.scss";

export const GridBreak = () => {
    return <GridItem lg={12}/>
};

export const Grid = ({ children, className, style, centerContent = false }) => {
    return <div className={classNames(className, styles['grid'], { [styles['center-content']]: centerContent })} style={style}>
        {children}
    </div>
};

export const GridItem = ({ children, className, style, lg, md, sm }) => {
    return <div className={classNames(className, styles['grid-item'], lg && styles[`lg-${lg}`], md && styles[`md-${md}`], sm && styles[`sm-${sm}`])} style={style}>
        {children}
    </div>
}